import { TagModels } from '../../enums';

export interface ITagsSchema {
    id?: string;
    name: string;
    color?: string;
    model: TagModels;
}
